module.exports = {
  BUILD_NUMBER: '2026-10-29',
  PROJECT_VERSION: "hsckEMR.0.75",
};
